// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3NfHS","topBottomGutter":"Layout_topBottomGutter__11zL0"};